export default {
  steps: {
    setup_fee: 'Taxa de configuração',
    business_info: 'Informações da empresa',
    create_preview: 'Criar contrato de pré-visualização',
    preview: 'Pré-visualizar contrato',
    sign: 'Assinar contrato',
  },
  buttons: {
    next: 'Pré-visualizar contrato',
    save_and_continue: 'Guardar e continuar',
    update: 'Atualizar pré-visualização',
    cancel: 'Cancelar atual',
    skip: 'Ignorar criação de contrato',
  },
  create_preview: {
    header: 'Criar contrato de pré-visualização',
    description: 'Introduza os dados do destinatário do contrato. Ainda pode alterá-los antes de enviar.',
  },
  sign: {
    update_notice: 'Para atualizar o contrato, cancele o atual e edite os detalhes.',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar as alterações',
  },
};
